module.exports = __webpack_public_path__ + "static/images/components/TutorialArrow/images/border.2dab0e1f.png";


//////////////////
// WEBPACK FOOTER
// ./components/TutorialArrow/images/border.png
// module id = 2677
// module chunks = 11